export default __webpack_public_path__ + "static/media/warning--kiwi-crossing--g1.1d1fffc2.png";